import React from 'react';
import { useEpiEcdRootPageContent } from '../../hooks/useEpiEcdRootPageContent';
import { Wysiwyg } from '../wysiwyg';

export function AppFooter() {
    const ecdRootPage = useEpiEcdRootPageContent();

    return (
        <footer className='ecd-footer'>            
            <div className='ecd-footer-content'>
                <Wysiwyg content={ecdRootPage?.footer} />
            </div>            
        </footer>
    );
}